<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="stroke-current"
    height="24"
    width="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
      d="M12 16.7l-7-8h14l-7 8z"
    />
  </svg>
</template>

<script>
/*
 !!TODO: Must be reviewed after the MVP has been introduced.
 !!This file should be refactored if necessary.
 *----------------------------------------------------------*
 !!author: Christopher Bomm
*/
export default {}
</script>
